// auto-generated by Typewriter template _enums.tst from PortCall.Models\Rights.cs
export enum UserProfileRights { 
    View = 1,
    Edit = 2,
    EditRoles = 4,
    MarkNotificationsAsViewed = 8,
    ViewContactInfo = 16,
    None = 0
}

export const UserProfileRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'EditRoles',
    8: 'MarkNotificationsAsViewed',
    16: 'ViewContactInfo',
    0: 'None'
}

export const UserProfileRightses : { Id : UserProfileRights, Name : string }[] = [ 
    { Id: UserProfileRights.View, Name: 'View' },
    { Id: UserProfileRights.Edit, Name: 'Edit' },
    { Id: UserProfileRights.EditRoles, Name: 'EditRoles' },
    { Id: UserProfileRights.MarkNotificationsAsViewed, Name: 'MarkNotificationsAsViewed' },
    { Id: UserProfileRights.ViewContactInfo, Name: 'ViewContactInfo' },
    { Id: UserProfileRights.None, Name: 'None' }
]

export enum PortRights { 
    View = 1,
    Edit = 2,
    None = 0
}

export const PortRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    0: 'None'
}

export const PortRightses : { Id : PortRights, Name : string }[] = [ 
    { Id: PortRights.View, Name: 'View' },
    { Id: PortRights.Edit, Name: 'Edit' },
    { Id: PortRights.None, Name: 'None' }
]

export enum BerthRights { 
    View = 1,
    Edit = 2,
    Reserve = 4,
    EditSchedulingAuthority = 8,
    AddClosure = 16,
    None = 0
}

export const BerthRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'Reserve',
    8: 'EditSchedulingAuthority',
    16: 'AddClosure',
    0: 'None'
}

export const BerthRightses : { Id : BerthRights, Name : string }[] = [ 
    { Id: BerthRights.View, Name: 'View' },
    { Id: BerthRights.Edit, Name: 'Edit' },
    { Id: BerthRights.Reserve, Name: 'Reserve' },
    { Id: BerthRights.EditSchedulingAuthority, Name: 'EditSchedulingAuthority' },
    { Id: BerthRights.AddClosure, Name: 'AddClosure' },
    { Id: BerthRights.None, Name: 'None' }
]

export enum PierGroupRights { 
    View = 1,
    Edit = 2,
    EditOrder = 4,
    EditPort = 8,
    Delete = 16,
    IgnorePreventAgentOverlaps = 32,
    IgnoreRequireKnownVessels = 64,
    IgnoreAgentChangeWindow = 128,
    None = 0
}

export const PierGroupRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'EditOrder',
    8: 'EditPort',
    16: 'Delete',
    32: 'IgnorePreventAgentOverlaps',
    64: 'IgnoreRequireKnownVessels',
    128: 'IgnoreAgentChangeWindow',
    0: 'None'
}

export const PierGroupRightses : { Id : PierGroupRights, Name : string }[] = [ 
    { Id: PierGroupRights.View, Name: 'View' },
    { Id: PierGroupRights.Edit, Name: 'Edit' },
    { Id: PierGroupRights.EditOrder, Name: 'EditOrder' },
    { Id: PierGroupRights.EditPort, Name: 'EditPort' },
    { Id: PierGroupRights.Delete, Name: 'Delete' },
    { Id: PierGroupRights.IgnorePreventAgentOverlaps, Name: 'IgnorePreventAgentOverlaps' },
    { Id: PierGroupRights.IgnoreRequireKnownVessels, Name: 'IgnoreRequireKnownVessels' },
    { Id: PierGroupRights.IgnoreAgentChangeWindow, Name: 'IgnoreAgentChangeWindow' },
    { Id: PierGroupRights.None, Name: 'None' }
]

export enum PortCallRights { 
    View = 1,
    Edit = 2,
    EditActuals = 4,
    EditUnlistedOverride = 8,
    EditRafting = 16,
    Book = 32,
    Cancel = 64,
    Delete = 128,
    None = 0
}

export const PortCallRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'EditActuals',
    8: 'EditUnlistedOverride',
    16: 'EditRafting',
    32: 'Book',
    64: 'Cancel',
    128: 'Delete',
    0: 'None'
}

export const PortCallRightses : { Id : PortCallRights, Name : string }[] = [ 
    { Id: PortCallRights.View, Name: 'View' },
    { Id: PortCallRights.Edit, Name: 'Edit' },
    { Id: PortCallRights.EditActuals, Name: 'EditActuals' },
    { Id: PortCallRights.EditUnlistedOverride, Name: 'EditUnlistedOverride' },
    { Id: PortCallRights.EditRafting, Name: 'EditRafting' },
    { Id: PortCallRights.Book, Name: 'Book' },
    { Id: PortCallRights.Cancel, Name: 'Cancel' },
    { Id: PortCallRights.Delete, Name: 'Delete' },
    { Id: PortCallRights.None, Name: 'None' }
]

export enum RecurringBatchRights { 
    View = 1,
    Delete = 2,
    None = 0
}

export const RecurringBatchRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Delete',
    0: 'None'
}

export const RecurringBatchRightses : { Id : RecurringBatchRights, Name : string }[] = [ 
    { Id: RecurringBatchRights.View, Name: 'View' },
    { Id: RecurringBatchRights.Delete, Name: 'Delete' },
    { Id: RecurringBatchRights.None, Name: 'None' }
]

export enum BerthClosureRights { 
    View = 1,
    Edit = 2,
    None = 0
}

export const BerthClosureRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    0: 'None'
}

export const BerthClosureRightses : { Id : BerthClosureRights, Name : string }[] = [ 
    { Id: BerthClosureRights.View, Name: 'View' },
    { Id: BerthClosureRights.Edit, Name: 'Edit' },
    { Id: BerthClosureRights.None, Name: 'None' }
]

export enum OrganizationRights { 
    View = 1,
    Edit = 2,
    ManageUsers = 4,
    ManageBerths = 8,
    AddManagedBerth = 16,
    ManageBills = 32,
    None = 0
}

export const OrganizationRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'ManageUsers',
    8: 'ManageBerths',
    16: 'AddManagedBerth',
    32: 'ManageBills',
    0: 'None'
}

export const OrganizationRightses : { Id : OrganizationRights, Name : string }[] = [ 
    { Id: OrganizationRights.View, Name: 'View' },
    { Id: OrganizationRights.Edit, Name: 'Edit' },
    { Id: OrganizationRights.ManageUsers, Name: 'ManageUsers' },
    { Id: OrganizationRights.ManageBerths, Name: 'ManageBerths' },
    { Id: OrganizationRights.AddManagedBerth, Name: 'AddManagedBerth' },
    { Id: OrganizationRights.ManageBills, Name: 'ManageBills' },
    { Id: OrganizationRights.None, Name: 'None' }
]

export enum DomainRights { 
    View = 1,
    Edit = 2,
    ManageOrgs = 4,
    AddUnmanagedBerth = 8,
    AddVessel = 16,
    IgnorePreventAgentDoubleBookings = 32,
    ConfigureCoordinations = 64,
    None = 0
}

export const DomainRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'ManageOrgs',
    8: 'AddUnmanagedBerth',
    16: 'AddVessel',
    32: 'IgnorePreventAgentDoubleBookings',
    64: 'ConfigureCoordinations',
    0: 'None'
}

export const DomainRightses : { Id : DomainRights, Name : string }[] = [ 
    { Id: DomainRights.View, Name: 'View' },
    { Id: DomainRights.Edit, Name: 'Edit' },
    { Id: DomainRights.ManageOrgs, Name: 'ManageOrgs' },
    { Id: DomainRights.AddUnmanagedBerth, Name: 'AddUnmanagedBerth' },
    { Id: DomainRights.AddVessel, Name: 'AddVessel' },
    { Id: DomainRights.IgnorePreventAgentDoubleBookings, Name: 'IgnorePreventAgentDoubleBookings' },
    { Id: DomainRights.ConfigureCoordinations, Name: 'ConfigureCoordinations' },
    { Id: DomainRights.None, Name: 'None' }
]

export enum VesselRights { 
    View = 1,
    Edit = 2,
    EditDOS = 4,
    AddShiphandlingNote = 8,
    None = 0
}

export const VesselRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'EditDOS',
    8: 'AddShiphandlingNote',
    0: 'None'
}

export const VesselRightses : { Id : VesselRights, Name : string }[] = [ 
    { Id: VesselRights.View, Name: 'View' },
    { Id: VesselRights.Edit, Name: 'Edit' },
    { Id: VesselRights.EditDOS, Name: 'EditDOS' },
    { Id: VesselRights.AddShiphandlingNote, Name: 'AddShiphandlingNote' },
    { Id: VesselRights.None, Name: 'None' }
]

export enum TrafficRights { 
    View = 1,
    None = 0
}

export const TrafficRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    0: 'None'
}

export const TrafficRightses : { Id : TrafficRights, Name : string }[] = [ 
    { Id: TrafficRights.View, Name: 'View' },
    { Id: TrafficRights.None, Name: 'None' }
]

export enum SharingRights { 
    View = 1,
    Edit = 2,
    None = 0
}

export const SharingRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    0: 'None'
}

export const SharingRightses : { Id : SharingRights, Name : string }[] = [ 
    { Id: SharingRights.View, Name: 'View' },
    { Id: SharingRights.Edit, Name: 'Edit' },
    { Id: SharingRights.None, Name: 'None' }
]

export enum TopicCardRights { 
    View = 1,
    Edit = 2,
    Confirm = 4,
    None = 0
}

export const TopicCardRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Edit',
    4: 'Confirm',
    0: 'None'
}

export const TopicCardRightses : { Id : TopicCardRights, Name : string }[] = [ 
    { Id: TopicCardRights.View, Name: 'View' },
    { Id: TopicCardRights.Edit, Name: 'Edit' },
    { Id: TopicCardRights.Confirm, Name: 'Confirm' },
    { Id: TopicCardRights.None, Name: 'None' }
]

export enum PortCallTopicCardTemplateRights { 
    AnswerTemplate = 1,
    None = 0
}

export const PortCallTopicCardTemplateRightsDisplayName : { [val : number] : string } = { 
    1: 'AnswerTemplate',
    0: 'None'
}

export const PortCallTopicCardTemplateRightses : { Id : PortCallTopicCardTemplateRights, Name : string }[] = [ 
    { Id: PortCallTopicCardTemplateRights.AnswerTemplate, Name: 'AnswerTemplate' },
    { Id: PortCallTopicCardTemplateRights.None, Name: 'None' }
]

export enum TopicCardTemplateUserAssignmentRights { 
    CanAssign = 1,
    None = 0
}

export const TopicCardTemplateUserAssignmentRightsDisplayName : { [val : number] : string } = { 
    1: 'CanAssign',
    0: 'None'
}

export const TopicCardTemplateUserAssignmentRightses : { Id : TopicCardTemplateUserAssignmentRights, Name : string }[] = [ 
    { Id: TopicCardTemplateUserAssignmentRights.CanAssign, Name: 'CanAssign' },
    { Id: TopicCardTemplateUserAssignmentRights.None, Name: 'None' }
]

export enum EventRights { 
    ViewComments = 1,
    Comment = 2,
    None = 0
}

export const EventRightsDisplayName : { [val : number] : string } = { 
    1: 'ViewComments',
    2: 'Comment',
    0: 'None'
}

export const EventRightses : { Id : EventRights, Name : string }[] = [ 
    { Id: EventRights.ViewComments, Name: 'ViewComments' },
    { Id: EventRights.Comment, Name: 'Comment' },
    { Id: EventRights.None, Name: 'None' }
]

export enum JobOrderRights { 
    ViewComments = 1,
    Comment = 2,
    None = 0
}

export const JobOrderRightsDisplayName : { [val : number] : string } = { 
    1: 'ViewComments',
    2: 'Comment',
    0: 'None'
}

export const JobOrderRightses : { Id : JobOrderRights, Name : string }[] = [ 
    { Id: JobOrderRights.ViewComments, Name: 'ViewComments' },
    { Id: JobOrderRights.Comment, Name: 'Comment' },
    { Id: JobOrderRights.None, Name: 'None' }
]

export enum CoordinationCardRights { 
    View = 1,
    EditStatus = 2,
    Cancel = 4,
    ChangeProvider = 8,
    None = 0
}

export const CoordinationCardRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'EditStatus',
    4: 'Cancel',
    8: 'ChangeProvider',
    0: 'None'
}

export const CoordinationCardRightses : { Id : CoordinationCardRights, Name : string }[] = [ 
    { Id: CoordinationCardRights.View, Name: 'View' },
    { Id: CoordinationCardRights.EditStatus, Name: 'EditStatus' },
    { Id: CoordinationCardRights.Cancel, Name: 'Cancel' },
    { Id: CoordinationCardRights.ChangeProvider, Name: 'ChangeProvider' },
    { Id: CoordinationCardRights.None, Name: 'None' }
]

export enum CoordinationCardSelfRights { 
    View = 1,
    Comment = 2,
    None = 0
}

export const CoordinationCardSelfRightsDisplayName : { [val : number] : string } = { 
    1: 'View',
    2: 'Comment',
    0: 'None'
}

export const CoordinationCardSelfRightses : { Id : CoordinationCardSelfRights, Name : string }[] = [ 
    { Id: CoordinationCardSelfRights.View, Name: 'View' },
    { Id: CoordinationCardSelfRights.Comment, Name: 'Comment' },
    { Id: CoordinationCardSelfRights.None, Name: 'None' }
]



// WEBPACK FOOTER //
// ./server/enums/Rights.ts